import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModelinferencingPageRoutingModule } from './modelinferencing-routing.module';

import { ModelinferencingPage } from './modelinferencing.page';
import { HttpClientModule } from '@angular/common/http';
import { FormModalComponent } from '../components/form-modal/form-modal.component';  // Import the modal



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModelinferencingPageRoutingModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  declarations: [ModelinferencingPage]
})
export class ModelinferencingPageModule {}
